import axios from "axios";
import { API_BASE_URL } from "./constants";

export default class OrganizationService {
  static getOrganization(organizationId) {
    return axios.get(API_BASE_URL + "organizations/" + organizationId);
  }
}
